import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { RecipeListPage } from './RecipeListPage';
import { RecipeDetailPage } from './RecipeDetailPage';
import { RecipeCreatePage } from './RecipeCreatePage';
import { LearnedRecipesPage } from './LearnedRecipesPage';
import { CraftingLogPage } from './CraftingLogPage';

/**
 * Arche wrapper for Crafting — provides ArcheLayout with sidebar
 * and handles sub-routing for all crafting admin pages.
 */
export function CraftingArchePage() {
  return (
    <ArcheLayout>
      <Routes>
        <Route path="/" element={<RecipeListPage />} />
        <Route path="/recipes/new" element={<RecipeCreatePage />} />
        <Route path="/recipes/:recipeId" element={<RecipeDetailPage />} />
        <Route path="/learned" element={<LearnedRecipesPage />} />
        <Route path="/log" element={<CraftingLogPage />} />
      </Routes>
    </ArcheLayout>
  );
}
